import React from 'react';
import { useHistory } from 'react-router-dom';

/**
 *
 * @returns {[module:url.URLSearchParams,((function(module:url.URLSearchParams): void))]}
 */
export default function useIsDigitalOnboarding() {
  const history = useHistory();

  return React.useMemo(() => {
    return history.location.pathname === '/welcome/onboarding';
  }, [history.location.pathname]);
}
